import { all, takeEvery, call, put, select } from 'redux-saga/effects';
import { findUpdatePackages } from '../../../api/devices/devices.api';
import actions from './actions';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import notifications from '../notification/actions';
import {getDeviceType} from "../deviceVersion/selectors";

function* fetchUpdatePackages(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO
        }
        const response = yield call(findUpdatePackages, params ? params : {});
        if (response.packages) {
            yield put(actions.fetchUpdatePackagesSuccess(response.packages));
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_UPDATE_PACKAGES_ERROR,
            }));
        }
    } catch(error) {
        yield put(notifications.createNotification({
            code: SERVER_ERRORS.COULD_NOT_FIND_DEVICES_EVENTS,
            mainAction: actions.FETCH_UPDATE_PACKAGES_ERROR,
        }))
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_UPDATE_PACKAGES, fetchUpdatePackages),
    ]);
}
